export const EDITOR_MANUAL_URL =
  'https://scn7nr4axh9v.feishu.cn/wiki/ERkvwepREisrvukKa6tcTC9GnMe?from=from_copylink'
export const EDITOR_QUICK_GUIDE_URL =
  'https://scn7nr4axh9v.feishu.cn/docx/JTs6dMJB0oiQ5Kxd1zqc5fZ6nff?from=from_copylink'
